/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * CloudQuery Platform OpenAPI Spec
 * Welcome to the CloudQuery Platform API documentation! This API can be used to interact with the CloudQuery platform. As a user, the API allows you to search the CloudQuery asset inventory, run SQL queries against the data warehouse, save and load searches, and much more. As an administrator, it allows you to manage your teams, syncs, and other objects.
### Authentication
The API is secured using bearer tokens. To get started, you can generate an API key for your Platform deployment from your platform dashboard. For a step-by-step guide, see: https://docs.cloudquery.io/docs/deployment/generate-api-key.
The base URL for the API depends on where your CloudQuery Platform is hosted. If running locally, this is usually http://localhost:3000/api. In a production deployment it should be an HTTPS URL. For purposes of illustration, we will assume the platform instance is available at https://cloudquery.mycompany.com. In this case, the base API endpoint will be https://cloudquery.mycompany.com/api.
### Example Request
To test your connection to the API, we can use the `/plugins` endpoint. For example:
`curl -v -H "Authorization: Bearer $CLOUDQUERY_API_KEY" \ https://cloudquery.mycompany.com/api/plugins`

 * OpenAPI spec version: 1.0.0
 */

export type PlatformLocalUserProvider = typeof PlatformLocalUserProvider[keyof typeof PlatformLocalUserProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformLocalUserProvider = {
  local: 'local',
  saml: 'saml',
} as const;
